/**
 * Development mode console utility
 * Only shows console logs in development mode
 */

const isDevMode = (): boolean => {
  // Check if we're in development mode
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.startsWith('192.168.') ||
      hostname.includes('.local') ||
      new URLSearchParams(window.location.search).get('debug') === 'true' ||
      (typeof localStorage !== 'undefined' && localStorage.getItem('app_debug') === 'true')
    );
  }
  // For Vite environments
  return import.meta.env.VITE_MODE === 'development';
};

// Store original console methods
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug,
};

// Override console methods to only work in development
if (typeof window !== 'undefined') {
  console.log = function(...args: any[]) {
    if (isDevMode()) {
      originalConsole.log.apply(console, args);
    }
  };

  console.warn = function(...args: any[]) {
    if (isDevMode()) {
      originalConsole.warn.apply(console, args);
    }
  };

  console.info = function(...args: any[]) {
    if (isDevMode()) {
      originalConsole.info.apply(console, args);
    }
  };

  console.debug = function(...args: any[]) {
    if (isDevMode()) {
      originalConsole.debug.apply(console, args);
    }
  };

  // Keep console.error in production for critical errors
  // But you can uncomment this if you want to hide errors too
  // console.error = function(...args: any[]) {
  //   if (isDevMode()) {
  //     originalConsole.error.apply(console, args);
  //   }
  // };
}

export { isDevMode };

